export default function NotFound() {
  return (
    <div className="flex h-screen items-center justify-center">
      <img
        src={`${process.env.PUBLIC_URL}/blorp_logo.png`}
        alt="[blorp logo]"
        className="w-48 h-48 object-contain lg:w-72 lg:h-72"
      />
      <h1 className="p-4 text-2xl font-bold">404 – Page Not Found</h1>
    </div>
  );
}
